export default __webpack_public_path__ + "static/media/ed_5.228af28c.mp3";